
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/small",
      function () {
        return require("private-next-pages/small/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/small"])
      });
    }
  